import ConsoleApi from "apps/console/enums/consoleApi";
import { QueryClient } from "react-query";
import { getApiQueryKey, useGetApiData } from "shared/datalayer";
import { ApiRegistration } from "shared/types/ApiRegistration";
import { setDefaultSupportEmail } from "shared/utils";
import PublicApi from "../../enums/PublicApi";

export function getRegDetailsKey({ regKey, registrationId }: { regKey?: string; registrationId?: string }) {
  if (registrationId) {
    return {
      api: ConsoleApi.GET_REGISTRATION_BY_ID,
      key: getApiQueryKey(ConsoleApi.GET_REGISTRATION_BY_ID, { params: { id: registrationId } })
    };
  }

  return {
    api: PublicApi.REG_DETAIL,
    key: getApiQueryKey(PublicApi.REG_DETAIL, { params: { key: regKey } })
  };
}

/**
 * @name useGetRegDetails
 * @description This is used to get reg detail by key
 * @param regKey
 */
export function useGetRegDetails({
  regKey,
  registrationId,
  successHandler
}: {
  regKey?: string;
  registrationId?: string;
  successHandler?: (data: ApiRegistration) => void;
}) {
  const apiDetail = getRegDetailsKey({ regKey, registrationId });
  return useGetApiData<ApiRegistration>(
    apiDetail.api,
    { params: { key: regKey, id: registrationId } },
    {
      enabled: Boolean(regKey) || Boolean(registrationId),
      onError: err => {},
      onSuccess: data => {
        setDefaultSupportEmail(data.helpdeskEmail);
        successHandler?.(data);
      },
      queryKey: apiDetail.key
    }
  );
}

export function updateRegDetails({ queryClient, data }: { queryClient: QueryClient; data: any }) {
  queryClient.setQueryData(getRegDetailsKey({ regKey: data.key, registrationId: data.id }).key, (value: any) => {
    return { ...value, ...data };
  });
}

export function refetchRegDetails({
  queryClient,
  registrationId
}: {
  queryClient: QueryClient;
  registrationId?: string;
}) {
  queryClient.refetchQueries(getRegDetailsKey({ registrationId }).key);
}
